module.exports = __webpack_public_path__ + "static/media/hariadi-1.487a2d98.jpg";